import React, { useEffect, useMemo, useRef, useState } from "react";
import Fade from "@mui/material/Fade";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "swiper";
import deleteTemplate from "../../Assets/Images/deleteTemplate.svg";
import { Col, Row } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import {
  DeleteTemplateByID,
  GetTemplateData,
} from "../../actions/Template/Template";
import { setImageUrl } from "../../Redux/MainImage/imageSlice";
import { setID } from "../../Redux/UserSlice/userSlice";
import { useTranslation } from "react-i18next";
import { setWaterMarksLoader } from "../../Redux/WaterMarks/wateramarks";

const TemplateListSlider = () => {
  const userSliceState = useSelector((state) => state["userSlice"]);
  const [templates, setTemplates] = useState([]);
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const memoizedTemplates = useMemo(() => templates, [templates]);

  const dispatch = useDispatch();
  useEffect(() => {
    setTemplates(userSliceState.template);
  }, [userSliceState.template]);
  useEffect(() => {
    if (selected) {
      // dispatch(setLoader(true));
      dispatch(setID(selected));
      dispatch(GetTemplateData(selected, [], false, true));
      dispatch(
        setImageUrl({
          url: ["base64"],
          name: "name",
          metadata: "",
        })
      );
    }
  }, [selected]);

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setIdToDelete(id);
  };

  const swiperRef = useRef(null);

  const handlePrevSlide = () => {
    swiperRef.current.swiper.slidePrev();
  };

  const handleNextSlide = () => {
    swiperRef.current.swiper.slideNext();
  };

  return (
    <>
      <Row className="w-100">
        <Row className="w-75 border-bottom side_margin_left side_margin_right">
          <Col className="productSansBold text_30"> {t("myTemplates")} </Col>
          <Col>
            {templates.length > 9 && (
              <div className="d-flex justify-content-end">
                <div>
                  <svg
                    onClick={handlePrevSlide}
                    className="me-3"
                    style={{
                      cursor: "pointer",
                    }}
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="21.5"
                      cy="21.5"
                      r="21"
                      transform="matrix(-1 0 0 1 43 0)"
                      fill="white"
                      stroke="#F36573"
                    />
                    <path
                      d="M24.785 15.349C24.8537 15.2727 24.9074 15.1829 24.943 15.0848C24.9786 14.9866 24.9955 14.8821 24.9927 14.7771C24.9899 14.6721 24.9674 14.5688 24.9265 14.4729C24.8857 14.3771 24.8272 14.2906 24.7546 14.2185C24.6819 14.1463 24.5964 14.0899 24.503 14.0525C24.4096 14.0151 24.31 13.9974 24.2101 14.0003C24.1101 14.0033 24.0117 14.0269 23.9205 14.0698C23.8292 14.1127 23.7469 14.1741 23.6782 14.2505L17.2081 21.4462C17.0744 21.5947 17 21.7912 17 21.9955C17 22.1998 17.0744 22.3963 17.2081 22.5448L23.6782 29.7414C23.7465 29.8194 23.8288 29.8824 23.9203 29.9267C24.0119 29.971 24.111 29.9957 24.2118 29.9995C24.3126 30.0033 24.413 29.9859 24.5074 29.9486C24.6018 29.9112 24.6881 29.8545 24.7614 29.7818C24.8347 29.7091 24.8936 29.6218 24.9345 29.525C24.9754 29.4282 24.9976 29.3238 24.9998 29.2179C25.002 29.112 24.9842 29.0067 24.9473 28.9081C24.9104 28.8095 24.8552 28.7196 24.785 28.6436L18.8081 21.9955L24.785 15.349Z"
                      fill="#F36573"
                    />
                  </svg>

                  <svg
                    width="43"
                    height="43"
                    onClick={handleNextSlide}
                    style={{
                      cursor: "pointer",
                    }}
                    viewBox="0 0 43 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="21.5"
                      cy="21.5"
                      r="21"
                      fill="white"
                      stroke="#F36573"
                    />
                    <path
                      d="M18.215 15.349C18.1463 15.2727 18.0926 15.1829 18.057 15.0848C18.0214 14.9866 18.0045 14.8821 18.0073 14.7771C18.0101 14.6721 18.0326 14.5688 18.0735 14.4729C18.1143 14.3771 18.1728 14.2906 18.2454 14.2185C18.3181 14.1463 18.4036 14.0899 18.497 14.0525C18.5904 14.0151 18.69 13.9974 18.7899 14.0003C18.8899 14.0033 18.9883 14.0269 19.0795 14.0698C19.1708 14.1127 19.2531 14.1741 19.3218 14.2505L25.7919 21.4462C25.9256 21.5947 26 21.7912 26 21.9955C26 22.1998 25.9256 22.3963 25.7919 22.5448L19.3218 29.7414C19.2535 29.8194 19.1712 29.8824 19.0797 29.9267C18.9881 29.971 18.889 29.9957 18.7882 29.9995C18.6874 30.0033 18.587 29.9859 18.4926 29.9486C18.3982 29.9112 18.3119 29.8545 18.2386 29.7818C18.1653 29.7091 18.1064 29.6218 18.0655 29.525C18.0246 29.4282 18.0024 29.3238 18.0002 29.2179C17.998 29.112 18.0158 29.0067 18.0527 28.9081C18.0896 28.8095 18.1448 28.7196 18.215 28.6436L24.1919 21.9955L18.215 15.349Z"
                      fill="#F36573"
                    />
                  </svg>
                </div>
              </div>
            )}
          </Col>
        </Row>
        <Row className="d-flex justify-content-center w-75 side_margin_left side_margin_right mt-4">
          <Swiper
            ref={swiperRef}
            slidesPerView={9.5}
            spaceBetween={20}
            pagination={{
              clickable: true,
              el: null,
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {/* <SwiperSlide className="d-flex justify-content-start align-items-start"> {/* w_10 */}
            {/* <div>{"asdf" + template.id}</div> */}

            {/* </SwiperSlide> */}
            {memoizedTemplates.length &&
              memoizedTemplates?.map((template, i) => (
                <SwiperSlide key={i} className="d-flex justify-content-center ">
                  {" "}
                  {/* w_10 */}
                  {/* <div>{"asdf" + template.id}</div> */}
                  <Col className="d-flex flex-column align-items-center position-relative w-100">
                    {/* Image with src="deleteTemplate" */}
                    <Row className="mt-2 deletePlaceHolder m-0 p-0">
                      <img
                        alt="delete"
                        onClick={() => {
                          handleDeleteModal(template.id);
                        }}
                        className="bg_delete p-1 size_12x9 m-0 cursor-pointer"
                        src={deleteTemplate}
                      />
                    </Row>
                    {/* Image with src="template.media.originalUrl" */}
                    <img
                      className={`rounded ${
                        selected === template.id
                          ? "borderTempaltesSelected"
                          : "borderTempaltes"
                      } bg-white`}
                      src={template.media.thumbUrl}
                      onClick={() => {
                        dispatch(setWaterMarksLoader(true));
                        setSelected(template.id);
                      }}
                      alt={template.name}
                      key={template.id}
                    />

                    {/* Name of the template */}
                    <Row className="w-100 h-100 text_16 overflow-visible text-truncate p-2 py-1 d-flex justify-content-between">
                      {template.name}
                    </Row>
                  </Col>
                </SwiperSlide>
              ))}
          </Swiper>
        </Row>
      </Row>
      <Modal
        open={deleteModal}
        onClose={() => {
          setDeleteModal(false);
          setIdToDelete(null);
        }}
        closeAfterTransition
      >
        <Fade in={deleteModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
            }}
            className="p-4 bg-white rounded-4"
          >
            <h4 className="deleteTempateHeading aktiv text-center text-black">
              Delete Template?
            </h4>
            <p className="text-center text-black aktiv">
              You’re about to delete this template permanently.
              <br />
              This can’t be undone.
            </p>
            <div className="d-flex justify-content-center mt-4">
              <button
                className="button_text text-light m-0 w_8_rem py-1 mx-2 bgDisabled border-0 d-flex justify-content-center align-items-center button_text_signin"
                onClick={() => {
                  setDeleteModal(false);
                  setIdToDelete(null);
                }}
              >
                Cancel
              </button>
              <button
                className={`button_text text-light m-0 w_8_rem py-1 mx-2 bgCreate border-0 d-flex justify-content-center align-items-center button_text_signin`}
                onClick={() => {
                  dispatch(DeleteTemplateByID(idToDelete));
                  setDeleteModal(false);
                }}
              >
                Delete
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
      {/* <UploadImage
        open={importImage}
        setOpen={setImportImage}
        multiple={false}
        choice={0}
        parent={true}
        handleClean={() => {
          setImportImage(false);
        }}
      /> */}
    </>
  );
};

export default TemplateListSlider;
